import type { OutcomeDefinition } from "@repo/app-types/entities/outcome";
import type { TopicMatch } from "@repo/app-types/entities/topic";
import type { FC } from "react";
import {
  GradingCustomerExperienceScorePill,
  type CustomerExperienceScoreValue,
} from "../../teammatePerformance/gradingCustomerExperienceScorePill.js";
import {
  MatchListItem,
  RECENT_MATCHES_DISPLAY_LIMIT,
} from "../../transcriptViewer/matchListItem.js";

interface TopicMatchesListProps {
  matches: readonly TopicMatch[];
  outcomeDef: OutcomeDefinition | undefined;
  onSelectMatch: (match: TopicMatch) => void;
}

export const TopicMatchesList: FC<TopicMatchesListProps> = ({
  matches,
  outcomeDef,
  onSelectMatch,
}) => {
  const visibleMatches = matches.slice(0, RECENT_MATCHES_DISPLAY_LIMIT);
  if (visibleMatches.length === 0) {
    return (
      <p className="rounded-lg bg-gray-50 p-4 text-sm text-muted-foreground">
        No matches in this period.
      </p>
    );
  }
  return (
    <ul className="space-y-3">
      {visibleMatches.map((match) => (
        <li key={match.momentId}>
          <MatchListItem
            contactName={match.contactName}
            recordedAt={match.recordedAt}
            teammateName={match.teammateName}
            bodyText={match.quote ?? null}
            outcome={match.outcome}
            outcomeDef={outcomeDef}
            onClick={() => onSelectMatch(match)}
            className="rounded-lg border border-border-light bg-white"
            headerBadge={{
              label: "CX score",
              pill: (
                <GradingCustomerExperienceScorePill
                  score={
                    match.customerExperienceScore as CustomerExperienceScoreValue | null
                  }
                />
              ),
            }}
          />
        </li>
      ))}
    </ul>
  );
};
